import {createAction} from '@reduxjs/toolkit';
import {PersInfTO} from 'generated/JavaTO';

const NAMESPACE = 'persInf/'
export const openPersonInfoPopupAction = createAction<{ persNr: number, date: number }>(NAMESPACE + 'openPersonInfoPopup')
export const closePersonInfoPopupAction = createAction(NAMESPACE + 'closePersonInfoPopup')
export const persInfPerRowFetchAction = createAction<PersInfPerRowRequest>(NAMESPACE + 'persInfPerRowFetch')
export const persInfPerRowResponseAction = createAction<{ request: PersInfPerRowRequest, data: PersInfTO[] }>(NAMESPACE + 'persInfPerRowResponse')